"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakPoint = exports.SETTINGS = exports.HIDDEN = exports.VISIBLES = exports.NAMES = void 0;
exports.NAMES = {
    BIG_DESKTOP: 'xl',
    DESKTOP: 'lg',
    MEDIUM: 'md',
    TABLET: 'sm',
    MOBILE: 'xs'
};
const GRID_XL = 1512;
const GRID_XL_WIDTH = '90%';
const GRID_GAP_XL = 24;
const GRID_BREAKPOINT_XL = 1512;
const GRID_CONTAINER_PADDING_XL = 16;
const GRID_LG = 1224;
const GRID_LG_WIDTH = '95%';
const GRID_GAP_LG = 24;
const GRID_BREAKPOINT_LG = 1280;
const GRID_CONTAINER_PADDING_LG = 14;
const GRID_MD = 944;
const GRID_MD_WIDTH = '95%';
const GRID_GAP_MD = 16;
const GRID_BREAKPOINT_MD = 1024;
const GRID_CONTAINER_PADDING_MD = 12;
const GRID_SM = 704;
const GRID_SM_WIDTH = '95%';
const GRID_GAP_SM = 16;
const GRID_BREAKPOINT_SM = 768;
const GRID_CONTAINER_PADDING_SM = 12;
const GRID_XS = 328;
const GRID_XS_WIDTH = '100%';
const GRID_GAP_XS = 8;
const GRID_CONTAINER_PADDING_XS = 12;
exports.VISIBLES = [
    `.visible-${exports.NAMES.BIG_DESKTOP}`,
    `.visible-${exports.NAMES.DESKTOP}`,
    `.visible-${exports.NAMES.MEDIUM}`,
    `.visible-${exports.NAMES.TABLET}`,
    `.visible-${exports.NAMES.MOBILE}`,
];
exports.HIDDEN = [
    `.hidden-${exports.NAMES.BIG_DESKTOP}`,
    `.hidden-${exports.NAMES.DESKTOP}`,
    `.hidden-${exports.NAMES.MEDIUM}`,
    `.hidden-${exports.NAMES.TABLET}`,
    `.hidden-${exports.NAMES.MOBILE}`,
];
exports.SETTINGS = {
    [exports.NAMES.BIG_DESKTOP]: {
        maxWidth: GRID_XL,
        breakpoint: GRID_BREAKPOINT_XL,
        width: GRID_XL_WIDTH,
        gridGap: GRID_GAP_XL,
        columns: 16,
        containerPadding: GRID_CONTAINER_PADDING_XL,
    },
    [exports.NAMES.DESKTOP]: {
        maxWidth: GRID_LG,
        breakpoint: GRID_BREAKPOINT_LG,
        width: GRID_LG_WIDTH,
        gridGap: GRID_GAP_LG,
        columns: 12,
        containerPadding: GRID_CONTAINER_PADDING_LG,
    },
    [exports.NAMES.MEDIUM]: {
        maxWidth: GRID_MD,
        breakpoint: GRID_BREAKPOINT_MD,
        width: GRID_MD_WIDTH,
        gridGap: GRID_GAP_MD,
        columns: 12,
        containerPadding: GRID_CONTAINER_PADDING_MD,
    },
    [exports.NAMES.TABLET]: {
        maxWidth: GRID_SM,
        breakpoint: GRID_BREAKPOINT_SM,
        width: GRID_SM_WIDTH,
        gridGap: GRID_GAP_SM,
        columns: 12,
        containerPadding: GRID_CONTAINER_PADDING_SM,
    },
    [exports.NAMES.MOBILE]: {
        maxWidth: GRID_XS,
        width: GRID_XS_WIDTH,
        gridGap: GRID_GAP_XS,
        columns: 12,
        containerPadding: GRID_CONTAINER_PADDING_XS,
    }
};
const getBreakPoint = (name, propName) => {
    let res = '';
    if (exports.SETTINGS[name] && exports.SETTINGS[name][propName]) {
        res = exports.SETTINGS[name][propName];
    }
    return res;
};
exports.getBreakPoint = getBreakPoint;
exports.default = exports.SETTINGS;
//# sourceMappingURL=index.js.map